import { prop } from 'ramda';

import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { processFinancialFooter } from './financial/financial-footer';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicFinancialPublication
 */

/**
 * @typedef {DocumentSchema} FinancialPublicationSchema
 */

/**
 * Transform the given input into objects
 *
 * @param  {PrismicFinancialPublication} data
 * @return {FinancialPublicationSchema}
 */
const processFinancialPublication = (data) =>
  compact({
    uid: DocumentType.FINANCIAL_PUBLICATION,
    type: DocumentType.FINANCIAL_PUBLICATION,
    ...processFinancialFooter(data),
    filters: {
      [FILTER.MENU]: MENU.STATISTICS,
    },
  });

/**
 * Normalizr schema representing a financial publication page
 */
export const FinancialPublication = deprecatedPageEntity(
  DocumentType.FINANCIAL_PUBLICATION,
  {
    processStrategy: (entity) => ({
      ...processFinancialPublication(prop('data', entity)),
    }),
  }
);
